import { clearObj, formatDatesInPayload } from '@marfa/bo-utils';
import { ApiResourceMethod } from '@/api/api-requests-factory';
import { ReportListModel, ReportListRequestModel } from '@/models/report/report.model';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { ReportListFilterFields } from '@/models/report/report-list-filter.model';

export class GetReportListRequest extends ApiResourceMethod<ReportListModel> {
  public perform(params: ReportListRequestModel): Promise<ReportListModel> {
    const requestData = formatDatesInPayload({
      payload: { ...params },
      isUnixToString: false,
      isIncludeTime: true,
    }, [
      ReportListFilterFields.DATE_FROM,
      ReportListFilterFields.DATE_TO,
      ReportListFilterFields.EXCHANGE_RATE_DATE,
    ]);

    return this.performer.requestWithMapper(
      {
        params: clearObj(requestData),
      },
      (payload: BaseResponse<ReportListModel>): ReportListModel => payload.data,
    );
  }
}
